import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { IonPage, IonContent, IonDatetime, IonPicker } from '@ionic/react'
import { ForgetModal, UseHeader, Icon, AvatarImg, AvatarModal } from '@cps'
import { modalLayer, useHistoryNew, toast, getPlatform, getEnv, miniAppRouteTo } from '@utils'
import { memberMobx, activityMobx, storeMobx } from '@mobxStore'
import mktController from 'controllers/mktController'
import languageController from 'controllers/languageController'
import { getNickName } from 'common/utils/member'
import EditNickNameModal from '../components/EditNickNameModal'
import VerificationType from '../components/VerificationType'
import DisplayModeModal from '../components/DisplayModeModal'
import BindMobileModal from '../components/BindMobileModal'
import i18n from 'i18next'
import { ddayjs, localStore } from '@dt/fe-utils'
import './index.scss'
import ENV from '@env'

const { isWeixin, isAlipay, isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()
const { isDebug } = getEnv()

interface IProps { }

const Setting: FC<IProps> = () => {
  const history = useHistoryNew()
  const { memberInfo, memberExtra, updateMemberInfo } = memberMobx
  const { memberId, mobile, email, countryCode, nickName, hasLoginPwd, gender, avatarUrl, agreeTime } = memberInfo
  const [showNickModal, setShowNickModal] = useState<boolean>(false)
  const [showGender, setShowGender] = useState<boolean>(false)
  const getGender = () => {
    return [
      {
        name: 'gender',
        options: [
          {
            text: i18n.t('mkt.common.male'),
            value: '1',
          },
          {
            text: i18n.t('mkt.common.female'),
            value: '2',
          }
        ]
      }
    ]
  }
  // Component Eveent
  const handleLogout = () => {
    memberMobx.logout().then((res) => {
      if (res) history.goBack()
    })
  }
  const handleChangeInfo = ({ nickName, birthday, gender, extra }: { nickName?: string; birthday?: string; gender?: number; extra?: any }) => {
    updateMemberInfo({ nickName, birthday, gender, extra })
    if (showNickModal) {
      setShowNickModal(false)
    }
  }
  const handleMobileBind = () => {
    mktController.jumpBind(history, 'mobile')
  }
  const handleEmailBind = () => {
    mktController.jumpBind(history, 'email')
  }
  const handleGo = (path: string) => {
    history.push(path)
  }
  const resetPass = (isSet: boolean = false) => {
    if (mobile && email) {
      modalLayer(VerificationType, null, 'verificationType').then((type: any) => {
        goResetPass(type, isSet)
      })
    } else {
      let type = ''
      if (mobile) {
        type = 'mobile'
      } else if (email) {
        type = 'email'
      }
      goResetPass(type, isSet)
    }
  }
  const goResetPass = (type: string, isSet: boolean) => {
    let account: any = ''
    let countryVal: any = ''
    if (type === 'mobile') {
      account = mobile
      countryVal = countryCode
    } else if (type === 'email') {
      account = email
      countryVal = '0'
    }
    modalLayer(ForgetModal, {
      title: isSet ? i18n.t('mkt.member.setPassword') : i18n.t('mkt.member.resetPassword'),
      type: type as any,
      account: account,
      countryCode: countryVal,
    }, 'forgetModal').then(() => {
      toast({ message: i18n.t('mkt.member.resetSucc') })
      if (isSet) {
        handleChangeInfo({ extra: { posPayNeedPwd: !memberExtra.posPayNeedPwd } })
      }
    }).catch(() => { })
  }
  const changeMode = () => {
    modalLayer(DisplayModeModal, null, 'displayModeModal')
  }
  const changeNick = () => {
    if (isWeixinMiniProgram) {
      miniAppRouteTo({
        url: `/pages/improveInfo/index?jumpH5Page=${location.origin + '/my/setting'}`
      })
    } else {
      modalLayer(EditNickNameModal, null, 'editNickNameModal').then((res: any) => {
        handleChangeInfo({ nickName: res })
      })
    }
  }
  const setCardPwd = () => {
    if (hasLoginPwd) {
      handleChangeInfo({ extra: { posPayNeedPwd: !memberExtra.posPayNeedPwd } })
    } else {
      if (mobile || email) {
        resetPass(true)
      } else {
        modalLayer(BindMobileModal).then(() => {
          handleChangeInfo({ extra: { posPayNeedPwd: !memberExtra.posPayNeedPwd } })
        }).catch(() => { })
      }
    }
  }
  const changeAvatar = () => {
    if (isWeixinMiniProgram) {
      miniAppRouteTo({
        url: `/pages/improveInfo/index?jumpH5Page=${location.origin + '/my/setting'}`
      })
    } else {
      modalLayer(AvatarModal, { data: avatarUrl, name: nickName }).then((val: any) => {
        memberMobx.updateMemberInfo({
          avatarUrl: val || '',
        })
      })
    }
  }
  return (
    <IonPage className='setting-page'>
      <UseHeader title={i18n.t('pageName.setting')} onBack={() => mktController.goBack(history)} />
      <IonContent className='page-content'>
        <div className='fix-block fix-block-bg'></div>
        <div className='setting-list'>
          <div data-cypid='mmgChangeAvatar' className='setting-item' onClick={changeAvatar}>
            <div className='name'>{i18n.t('mkt.common.avatar')}</div>
            <div className='link'>
              <AvatarImg></AvatarImg>
              <Icon name='chevron-right' />
            </div>
          </div>
          <div data-cypid='mmgChangeNickName' className='setting-item' onClick={changeNick}>
            <div className='name'>{i18n.t('mkt.common.nickName')}</div>
            <div className='link'>
              <span>{getNickName(nickName)}</span>
              <Icon name='chevron-right' />
            </div>
          </div>
          <div className='setting-item'>
            <div className='name'>{i18n.t('mkt.common.memberNo')}</div>
            <div className='link'>
              <span>{memberId}</span>
            </div>
          </div>
          <div
            data-cypid='mmgChangeGender'
            className='setting-item' onClick={() => {
              setShowGender(true)
            }}
          >
            <div className='name'>{i18n.t('mkt.common.sex')}</div>
            <div className='link'>
              <span>{gender === null || gender === '0' ? i18n.t('mkt.common.unSet') : gender === '1' ? i18n.t('mkt.common.male') : i18n.t('mkt.common.female')}</span>
              <Icon name='chevron-right' />
            </div>
          </div>
          <div className='setting-item setting-date'>
            <div className='name'>{i18n.t('mkt.common.birthday')}</div>
            <div className='link'>
              <span>{memberInfo.birthday || i18n.t('mkt.member.setYourBirthday')}</span>
              <Icon name='chevron-right' />
            </div>
            <IonDatetime
              className='picker-date'
              displayFormat='MM-DD'
              value={memberInfo.birthday ? memberInfo.birthday.replace('-', '/') : ''}
              placeholder={memberInfo.birthday || ''}
              pickerOptions={{
                cssClass: 'mkt-picker',
                buttons: [
                  {
                    text: i18n.t('mkt.common.cancel'),
                  },
                  {
                    text: i18n.t('mkt.common.confirm'),
                    handler: (e: any) => {
                      const val = `${e.month.text}-${e.day.text}`
                      handleChangeInfo({ birthday: val })
                    }
                  }
                ]
              }}
            />
          </div>
          <div data-cypid='mmgBindMobile' className='setting-item' onClick={handleMobileBind}>
            <div className='name'>{i18n.t('mkt.common.mobile')}</div>
            <div className='link'>
              {
                mobile ? <span>{mobile}</span>
                  : (
                    <>
                      {
                        activityMobx.bindMobileActive ? <span style={{ color: '#E50E2B' }}>{i18n.t('mkt.member.bindMobileCoupon')}</span> : <span>{i18n.t('mkt.common.unSet')}</span>
                      }
                    </>)
              }
              <Icon name='chevron-right' />
            </div>
          </div>
          <div data-cypid='mmgBindEmail' className='setting-item' onClick={handleEmailBind}>
            <div className='name'>{i18n.t('mkt.common.email')}</div>
            <div className='link'>
              <span> {email || i18n.t('mkt.common.unSet')}</span>
              <Icon name='chevron-right' />
            </div>
          </div>
          <div data-cypid='mmgToAdressBind' className='setting-item' onClick={() => handleGo('/my/address')}>
            <div className='name'>{i18n.t('mkt.common.shippingAddress')}</div>
            <div className='link'>
              <Icon name='chevron-right' />
            </div>
          </div>
          {
            !window.ODMINFO && (
              <div data-cypid='mmgToOtherBind' className='setting-item' onClick={() => handleGo('/my/othersBind')}>
                <div className='name'>{i18n.t('mkt.common.otherNum')}</div>
                <div className='link'>
                  <Icon name='chevron-right' />
                </div>
              </div>
            )
          }
        </div>
        <div className='fix-block'></div>
        {/* <div className='setting-list'>
          <div className='setting-item' onClick={changeMode}>
            <div className='name'>{i18n.t('mkt.setting.foodDisplayStyle')}</div>
            <div className='link'>
              {memberExtra.displayMode === '' && <span>{i18n.t('mkt.setting.autoChoose')}</span>}
              {memberExtra.displayMode === 'waterfall' && <span>{i18n.t('mkt.setting.waterfall')}</span>}
              {memberExtra.displayMode === 'list' && <span>{i18n.t('mkt.setting.list')}</span>}
              {memberExtra.displayMode === 'classic' && <span>{i18n.t('mkt.setting.classic')}</span>}
              <Icon name='chevron-right' />
            </div>
          </div>
        </div> */}
        <div className='setting-list'>
          <div className='setting-item'>
            <div className='name'>{i18n.t('mkt.member.cardusepwd')}</div>
            <div className='link'>
              <div data-cypid='mmgPosPayNeedPwd' className={`toggle ${!memberExtra.posPayNeedPwd ? 'toggle-off' : null}`} onClick={() => setCardPwd()}>
                <div className={`toggle-succ ${!memberExtra.posPayNeedPwd ? 'toggle-fail' : null}`}>{memberExtra.posPayNeedPwd && <Icon className='toggle-icon' name='check' />}</div>
              </div>
            </div>
          </div>
        </div>
        <div className='fix-block'></div>
        <div className='setting-list'>
          <div data-cypid='mmgToLanguage' className='setting-item' onClick={() => handleGo('/my/language')}>
            <div className='name'>{i18n.t('mkt.setting.languageSelect')}</div>
            <div className='link'>
              <span>{languageController.languageLabel[localStore.get(`i18nextLng.${Config.BRANDID}`)]}</span>
              <Icon name='chevron-right' />
            </div>
          </div>
        </div>
        <div className='fix-block'></div>
        <div className='setting-list'>
          {
            (mobile || email) && (
              <div data-cypid='mmgToResetPwd' className='setting-item' onClick={() => resetPass()}>
                <div className='name'>{i18n.t('mkt.member.resetPassword')}</div>
                <div className='link'> <Icon name='chevron-right' /></div>
              </div>
            )
          }
          {
            (isWeixin || isAlipay) && !isDebug
              ? ''
              : (
                <div data-cypid='mmgLogout' className='setting-item' onClick={handleLogout}>
                  <div className='name'>{i18n.t('mkt.common.loginOut')}</div>
                  <div className='link'> <Icon name='chevron-right' /></div>
                </div>
              )
          }
          {
            bo === 'cn' && (
              <div className='setting-item'>
                <div className='name'>用户协议</div>
                <div
                  data-cypid='mmgToUserClause'
                  className='link'
                  onClick={() => {
                    const url = `${ENV.gateWayUrl}/memberservice/open/getUserClause?brandId=${storeMobx.brand.brandId}&brandName=${storeMobx.brand.brandName}`
                    if (isWeixinMiniProgram) {
                      window.wx.miniProgram.navigateTo({
                        url: `/pages/webview/index?url=${encodeURIComponent(url)}`
                      })
                    } else if (isAliPayMiniProgram) {
                      window.my.navigateTo({
                        url: `/pages/webview/index?url=${encodeURIComponent(url)}`
                      })
                    } else {
                      location.href = url
                    }
                  }}
                >
                  {!!agreeTime && <span>{`${ddayjs(agreeTime).format('YYYY-MM-DD')} ${i18n.t('common.isagree')}`}</span>}
                  <Icon name='chevron-right' />
                </div>
              </div>
            )
          }
          {
            bo === 'cn' && (
              <div className='setting-item'>
                <div className='name'>隐私条款</div>
                <div
                  data-cypid='mmgToUserPrivate'
                  className='link'
                  onClick={() => {
                    const url = `${ENV.gateWayUrl}/memberservice/open/getPrivateClause?brandId=${storeMobx.brand.brandId}&brandName=${storeMobx.brand.brandName}`
                    if (isWeixinMiniProgram) {
                      window.wx.miniProgram.navigateTo({
                        url: `/pages/webview/index?url=${encodeURIComponent(url)}`
                      })
                    } else if (isAliPayMiniProgram) {
                      window.my.navigateTo({
                        url: `/pages/webview/index?url=${encodeURIComponent(url)}`
                      })
                    } else {
                      location.href = url
                    }
                  }}
                >
                  {!!agreeTime && <span>{`${ddayjs(agreeTime).format('YYYY-MM-DD')} ${i18n.t('common.isagree')}`}</span>}
                  <Icon name='chevron-right' />
                </div>
              </div>
            )
          }
          {
            isDebug && (
              <div className='setting-item'>
                <div className='name'>版本号</div>
                <div className='link'>
                  <span>V{window.buildinfo.buildDate.substr(2, 14).replace(/[-|:]/g, '').replace(' ', '-')}</span>
                </div>
              </div>
            )
          }
        </div>
        <IonPicker
          data-cypid='mmgGenderPicker'
          cssClass='mkt-picker'
          isOpen={showGender}
          columns={getGender()}
          mode='md'
          onDidDismiss={() => setShowGender(false)}
          buttons={[
            {
              text: i18n.t('mkt.common.cancel'),
              handler: () => {
                setShowGender(false)
              }
            },
            {
              text: i18n.t('mkt.common.confirm'),
              handler: (e) => {
                if (e.gender.value) {
                  handleChangeInfo({ gender: e.gender.value })
                }
              }
            }
          ]}
        />
      </IonContent>
    </IonPage>
  )
}

export default observer(Setting)
